export const OPENTYPE_FEATURE_GROUPS = {
    'Small Caps': ['c2sc', 'c2pc', 'smcp', 'pcap'],
    Replacements: [
        'calt',
        'salt',
        'jalt',
        'liga',
        'dlig',
        'hlig',
        'swsh',
        'cswh',
        'init',
        'fina',
    ],
    Figures: ['onum', 'lnum', 'tnum', 'pnum'],
    'Other Numerics': ['ordn', 'frac', 'numr', 'dnom', 'afrc', 'sinf', 'zero'],
    Punctuation: [],
    'Other Features': [
        'expt',
        'hist',
        'locl',
        'mgrk',
        'ornm',
        'subs',
        'sups',
        'vert',
    ],
};
